export function removeElements(selector: string) {
  const elements = document.querySelectorAll(selector)
  elements.forEach(element => {
    element.remove()
  })
}

export function createScriptElement(
  scriptOptions: { async?: boolean; defer?: boolean } = {},
  attributes: Record<string, string> = {},
) {
  const script = document.createElement('script')
  script.async = !!scriptOptions.async
  script.defer = !!scriptOptions.defer
  Object.keys(attributes).forEach(key => {
    script.setAttribute(key, attributes[key])
  })
  return script
}

export function createImageElement(attributes: Record<string, string> = {}) {
  const img = document.createElement('img')
  const finalAttributes: Record<string, string> = {
    ...attributes,
    role: 'presentation',
  }
  Object.keys(finalAttributes).forEach(key => {
    img.setAttribute(key, finalAttributes[key])
  })
  return img
}
